import React from "react";
import { Col, Row, Card } from "react-bootstrap";

import IconSpinner from "components/IconSpinner";

import "./EmployerCard.scss";

interface EmployerCardProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  content?: React.ReactNode;
  actionText?: string;
  completedAction?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

export const EmployerCard = ({
  title,
  description,
  loading,
  content,
}: EmployerCardProps) => {
  return (
    <div className="download-employee-template">
      <Row>
        <Col>
          <Card>
            <Card.Title>
              <p className="page-header">{title}</p>
              <p className="page-subtext">{description}</p>
            </Card.Title>
            <Card.Body>
              {loading && (
                <div className="action-card-action action-card-loading">
                  <IconSpinner />
                </div>
              )}
              {content}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EmployerCard;
